module.exports = __webpack_public_path__ + "img/item6.cd45a537.svg";